import { render } from "./HumorBlock.vue?vue&type=template&id=6379237a&scoped=true"
import script from "./HumorBlock.vue?vue&type=script&lang=js"
export * from "./HumorBlock.vue?vue&type=script&lang=js"

import "./HumorBlock.vue?vue&type=style&index=0&id=6379237a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6379237a"]])

export default __exports__